import React from 'react';
import '../css/Pricing.css';
import asset from '../assets/images';
import PricingSection from '../components/PricingSection';

const Packages = () => {
  return (
    <div className="about-carousel">
      <div className="slides">
        <div className="slide first">
          <img src={asset.pricing_hero} alt="About Image 1" />
          <div className="carousel-text">
            <h1>Photography Packages</h1>
          </div>
        </div>
      </div>
      <PricingSection />
    </div>
  );
}

export default Packages;
